/**
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */
// import { config, configqa, configprod} from '../config';
import { util, api } from '@keystone/common';

/**
 * A class for performing API calls to various back end services
 */
class ApiClient {
  getUser = (user, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/user?selectedClientId=${selectedCustomer}`,
        {
          method: 'get',
          headers: {
            Authorization: `Bearer ${user.idToken}`,
            loggedUser: user.email,
          },
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'User'));
        })
        .catch((err) => {
          console.log('caught an');
          reject(err);
        });
    });
  };

  createUser = (createUserForm, user, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/addUser?selectedClientId=${selectedCustomer}`,
        {
          method: 'post',
          headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${user.idToken}`,
            loggedUser: user.email,
            emailTemplateId: getEmailTemplateID(),
            flowId: getFlowID(),
          },
          body: JSON.stringify(createUserForm),
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'User'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  editUser = (editUserForm, user, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/updateUser?selectedClientId=${selectedCustomer}`,
        {
          method: 'put',
          headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${user.idToken}`,
            loggedUser: user.email,
            emailTemplateId: getEmailTemplateID(),
            flowId: getFlowID(),
          },
          body: JSON.stringify(editUserForm),
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'User'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  deleteUsers = (userNames, user, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/deleteUsers?selectedClientId=${selectedCustomer}`,
        {
          method: 'delete',
          headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${user.idToken}`,
            loggedUser: user.email,
            userNames,
          },
          body: JSON.stringify(userNames),
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'User'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchUsers = (user, selectedCustomer, selectedSite, signal) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/${selectedSite}/users?selectedClientId=${selectedCustomer}`,
        {
          method: 'get',
          headers: {
            Authorization: `Bearer ${user.idToken}`,
            loggedUser: user.email,
          },
          signal,
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'User'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  createOperator = (createOperatorForm, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/addOperator?selectedClientId=${selectedCustomer}`,
        {
          method: 'post',
          headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify(createOperatorForm),
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Operator'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  editOperator = (editOperatorForm, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/updateOperator?selectedClientId=${selectedCustomer}`,
        {
          method: 'put',
          headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify(editOperatorForm),
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Operator'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  deleteOperators = (operatorIds, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/deleteOperators?selectedClientId=${selectedCustomer}`,
        {
          method: 'delete',
          headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${idToken}`,
            operatorIds,
          },
          body: JSON.stringify(operatorIds),
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Operator'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchOperators = (idToken, selectedCustomer, selectedSite, signal) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/${selectedSite}/operators?selectedClientId=${selectedCustomer}`,
        {
          method: 'get',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
          signal,
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'operators'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchOperatorTemplates = (operator, idToken, selectedCustomer, signal) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/voice/template/gui/list?operatorIdentifier=${operator}&selectedClientId=${selectedCustomer}`,
        {
          method: 'get',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
          signal,
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Templates'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  deleteTemplate = (operator, selectedTemplateRow, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/voice/template/gui?path=${operator}%5C${
          selectedTemplateRow.parentDir
        }%5C${selectedTemplateRow.fileName}&selectedClientId=${selectedCustomer}`,
        {
          method: 'delete',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Template'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  deleteAllTemplate = (operator, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/voice/template/gui?path=${operator}%5C*%5C*.bt2&selectedClientId=${selectedCustomer}`,
        {
          method: 'delete',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Template'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  uploadTemplates = (data, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/voice/template/gui/upload?selectedClientId=${selectedCustomer}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
          body: data,
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Template'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchLogs = (idToken, deviceId, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/logs/getDeviceProblemLogs?deviceId=${deviceId}&selectedClientId=${selectedCustomer}`,
        {
          method: 'get',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Logging'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchAllLogs = (idToken, selectedCustomer, signal) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/logs/getProblemLogs?selectedClientId=${selectedCustomer}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
        signal,
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Logging'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchLicenseInfo = (idToken, clientId, signal) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/licenses/${getLicenseAPIVersion()}/customers/sentience/${clientId}`,
        {
          method: 'get',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
          signal,
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'LicenseInfo'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchDevices = (idToken, selectedCustomer, signal) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/deviceinfo/${util.getUserAPIVersion()}/getDevicesForCustomer?selectedClientId=${selectedCustomer}`,
        {
          method: 'get',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
          signal,
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'DeviceInfo'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchDeviceHistory = (serialNumber, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/deviceinfo/${util.getUserAPIVersion()}/getHistoryForDevice?deviceSerialNumber=${serialNumber}&selectedClientId=${selectedCustomer}`,
        {
          method: 'get',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'DeviceInfo'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  deleteDevices = (devices, user, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/deviceinfo/${util.getUserAPIVersion()}/remove?selectedClientId=${selectedCustomer}`,
        {
          method: 'delete',
          headers: {
            'content-type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${user.idToken}`,
          },
          body: devices,
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'DeviceInfo'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchSites = (idToken, selectedCustomer, signal) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/site/all?selectedClientId=${selectedCustomer}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
        signal,
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Site'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchSitesDropDown = (idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/site/all-short?selectedClientId=${selectedCustomer}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Site'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  createSite = (createSiteForm, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/site/add?selectedClientId=${selectedCustomer}`, {
        method: 'post',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify(createSiteForm),
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Site'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  editSite = (editSiteForm, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/site/edit?selectedClientId=${selectedCustomer}`, {
        method: 'put',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify(editSiteForm),
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Site'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  deleteSites = (siteIds, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/site/delete?selectedClientId=${selectedCustomer}`, {
        method: 'delete',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${idToken}`,
          siteIds,
        },
        body: JSON.stringify(siteIds),
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Site'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchOperatorSettings = (operatorId, idToken, selectedCustomer) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/settings/${operatorId}?selectedClientId=${selectedCustomer}`,
        {
          method: 'get',
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        }
      )
        .then(async (response) => {
          resolve(api.validateResponse(response, 'Operator Settings'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  updateUserPreferences = (idToken, prefs) => {
    return fetch(
      `${util.getAPIGatewayURL()}/user/admin/${util.getUserAPIVersion()}/update-user-preferences`,
      {
        method: 'post',
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify(prefs),
      }
    );
  };
}

export function getLicenseAPIVersion() {
  if (
    process.env.REACT_APP_LICENSE_API_VERSION === '' ||
    process.env.REACT_APP_LICENSE_API_VERSION === undefined
  ) {
    return 'v1';
  }
  return process.env.REACT_APP_LICENSE_API_VERSION;
}

export function getEmailTemplateID() {
  if (
    process.env.REACT_APP_EMAIL_TEMPLATE_ID === '' ||
    process.env.REACT_APP_EMAIL_TEMPLATE_ID === undefined
  ) {
    return 'f0ee1dc8-f3d7-453f-a3be-97f5b44530a1';
  }
  return process.env.REACT_APP_EMAIL_TEMPLATE_ID;
}

export function getFlowID() {
  if (process.env.REACT_APP_FLOW_ID === '' || process.env.REACT_APP_FLOW_ID === undefined) {
    return '39265acc-c9b8-4098-b8a8-0389a6b80ffb';
  }
  return process.env.REACT_APP_FLOW_ID;
}

export default new ApiClient();
